<div class="dropdown">
    <button class="btn btn-block text-left dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">{{selection}}</button>
    <div class="dropdown-menu">
        @for (choice of choices; track choice; let i = $index) {
            <a class="dropdown-item" href="#" (click)="clicked($event, i)">{{verb}} {{choice.phrase}}</a>
        }
        <div class="dropdown-divider"></div>
        <form [formGroup]="form" class="dropdown-item">
            <div class="form-group">
                <input type="date" class="form-control form-control-sm" formControlName="from" />
            </div>
            <div class="form-group">
                <input type="date" class="form-control form-control-sm" formControlName="to" />
            </div>
            <button class="btn btn-sm btn-block btn-primary" (click)="clicked($event, -1)">custom</button>
        </form>
    </div>
</div>